import{ useState, forwardRef, useImperativeHandle } from 'react';
import clsx from 'clsx'
import { Box, Button, Modal, Typography, Divider, IconButton, Checkbox, FormControlLabel} from '@mui/material';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import useMediaQuery from '../../../base/useMediaQuery';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: 400,
  width: "96%",
  bgcolor: 'background.paper',
  borderRadius: 2,
  p: 3,
};

interface IProps {
  message: string;
  button1Title: string;
  onPressBtn1: Function;
  button2Title?: string;
  onPressBtn2?: Function;
}

const AlertDialogModal = forwardRef((props: IProps, ref: any) => {
  const {
    message,
    includeTitle,
    button1Title,
    onPressBtn1,
    button2Title,
    onPressBtn2,
  } = props;

  const isDeskTop = useMediaQuery('(min-width: 400px)');

  const [openConfirmation, setOpenConfirmation] = useState(false)

  useImperativeHandle(ref, () => ({
    show() {
      setOpenConfirmation(true)
    }
  }));

  const onPressButton1 = () => {
    setOpenConfirmation(false)
    onPressBtn1()
  }

  const onPressButton2 = () => {
    setOpenConfirmation(false)
    onPressBtn2 && onPressBtn2();
  }

  return (
    <>
      <Modal 
        open={openConfirmation} 
        onClose={() => setOpenConfirmation(false)}
        // variant="outlined"
        role="alertdialog"
        aria-labelledby="alert-dialog-modal-title"
        aria-describedby="alert-dialog-modal-description"
      >
        <Box sx={style}>
          <h1
            className={clsx("flex items-center my-3 gap-2 text-[#00684E] font-['Poppins-Medium'] ", {
              "text-xl": isDeskTop,
              "text-[20px]": !isDeskTop
            })}
          >
            <WarningRoundedIcon /> Confirmation
          </h1>
          <hr />
          <Typography 
            id="alert-dialog-modal-description" 
            className={clsx("px-3 py-2 font-['Poppins-Regular'] leading-[30px]", {
              "text-[12px]": !isDeskTop,
              "text-[14px]": isDeskTop
            })}
          >
            {message}
          </Typography>
          <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end', pt: 2 }}>
            <Button className="font-['Poppins-Medium'] normal-case text-[14px]" sx={{ color: 'black' }} onClick={onPressButton1}>
              {button1Title}
            </Button>
            {button2Title && (
                <Button variant="contained" onClick={onPressButton2} className="bg-[#00684E] font-['Poppins-Medium'] normal-case text-[14px] text-white">
                    {button2Title}
                </Button>
            )}
          </Box>
        </Box>
      </Modal>
    </>
  );
})

export default AlertDialogModal;